import React, { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTheme } from '@mui/material/styles';
import { Box, Stack, Typography } from '@mui/material';
import { PrepayMobile, PrepaySIM } from '../../shared/CustomIcons.styled';
import PrepayCartItem from './PrepayCartItem';
import useStyles from './style';
import PrepayCartSummary from './PrepayCartSummary';
import PrepayTopUpAmount from './PrepayTopUpAmount';
import RootContext from '../../../../util/root.context';
import { ADDON_ITEM_GROUP, SERVICE_GROUPS } from '../../shared/Constants';
import EirCartPriceSummary from '../../eir-cart/EirCartPriceSummary';

const { SUBSCRIPTION } = ADDON_ITEM_GROUP;
const { MOBILE } = SERVICE_GROUPS;
/**
 * @name PrepayCartInfo - Prepay cart info
 * @param {object} summaryData - Local cms data object containing title ,subtitle etc
 * @param {object} cartData - cart info from getCart
 * @param {function} openConfirmationModal - function to open modal for deleting respective cart item
 * @returns {JSX.Element} - Returns Prepay cart info
 */
const PrepayCartInfo = ({
  cartData,
  loading,
  deleteIcon,
  openConfirmationModal,
  getClickedItem,
  summaryData,
  showTopUp,
  showPortingInfo,
  setShowPortingInfo,
  isCartDoc,
}) => {
  const theme = useTheme();
  const style = useStyles(theme);
  const { state: rootState } = useContext(RootContext);
  let addonDiscount = null;
  if (rootState.cart?.offers !== undefined) {
    addonDiscount = rootState.cart?.offers[0]?.addOns?.filter(
      addOn => addOn?.itemGroup === 'DISCOUNTS'
    )[0]?.discounts[0]?.value;
  }

  return (
    <Box>
      <Box>
        {cartData?.hasPrepayMobile && (
          <Box>
            <Stack direction='row' alignItems='flex-end'>
              {cartData?.handset?.flat()?.length > 0 ? <PrepayMobile /> : <PrepaySIM />}
              <Typography
                variant='subtitle1'
                sx={{ color: theme.palette.primary.textColor3, pl: '0.25rem' }}
              >
                {cartData?.handset?.flat()?.length > 0 ? 'Mobile' : 'SIM'}
              </Typography>
            </Stack>
            <Box sx={style.itemContainer}>
              {cartData?.cart
                ?.filter(res => res?.itemType === MOBILE)
                .map(cart => (
                  <>
                    <>
                      {cart?.prepayAddons?.map(
                        addOn =>
                          addOn?.itemType === SUBSCRIPTION && (
                            <PrepayCartItem
                              {...addOn}
                              portInInfo={cart?.portInInfo}
                              portInPhoneNumber={cart?.portInPhoneNumber}
                              portingDate={cart?.portingDate}
                              key={uuidv4()}
                              loading={loading}
                              cartData={cartData}
                              deleteIcon={deleteIcon}
                              openConfirmationModal={openConfirmationModal}
                              getClickedItem={getClickedItem}
                              showPortingInfo={showPortingInfo}
                              setShowPortingInfo={setShowPortingInfo}
                            />
                          )
                      )}
                      {cart?.handsetData?.map(set => (
                        <PrepayCartItem
                          {...set}
                          key={uuidv4()}
                          loading={loading}
                          cartData={cart}
                          AddonDiscount={addonDiscount}
                          deleteIcon={deleteIcon}
                          openConfirmationModal={openConfirmationModal}
                          getClickedItem={getClickedItem}
                        />
                      ))}
                    </>
                    {showTopUp && (
                      <PrepayTopUpAmount
                        key={uuidv4()}
                        cartData={cartData}
                        loading={loading}
                        deleteIcon={deleteIcon}
                        openConfirmationModal={openConfirmationModal}
                        getClickedItem={getClickedItem}
                      />
                    )}
                  </>
                ))}
            </Box>
          </Box>
        )}
      </Box>
      {!isCartDoc && <PrepayCartSummary cartData={cartData} summaryData={summaryData} />}
      {isCartDoc && <EirCartPriceSummary cartData={cartData} loading={loading} />}
    </Box>
  );
};

PrepayCartInfo.displayName = 'PrepayCartInfo';
export default PrepayCartInfo;
